import { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate} from "react-router-dom";
import Dashboard from "./components/Dashboard";
import Layout from "./components/shared/Layout";
import ClassManagement from "./components/ClassManagement";
import Students from "./components/Students";
import Messages from "./components/Messages";
import Support from "./components/Support";
import Settings from "./components/Settings";
import PerformanceTracker from "./components/PerformanceTracker";
import Staffs from "./components/Staffs";
import Login from "./components/Login";
import VideoClassManagement from "./components/VideoClassManagement";
import Payment from "./components/Payment";
import CourseManagement from "./components/CourseManagement";
import Token from "./components/Token";
import TimeTable from "./components/TimeTable";
import TransactionHistory from "./components/TransactionHistory";
import Statistics from "./components/Statistics";
import QuizManagement from "./components/QuizManagement";
import IpadLogin from "./components/ipad/IpadLogin";          
import IpadScanner from "./components/ipad/IpadScanner";
import axios from "axios";

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(null);
  const [userRole, setUserRole] = useState(null);

  axios.interceptors.request.use((config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });

  useEffect(() => {
    const checkAuth = async () => {
      const token = localStorage.getItem('authToken');
      const storedRole = localStorage.getItem('userRole');
      if (token && storedRole) {
        try {
          const response = await axios.get(`${process.env.REACT_APP_API_URL}/admin/verify`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          if (response.data.isValid) {
            setIsLoggedIn(true);
            setUserRole(response.data.role || storedRole); 
          } else {
            localStorage.removeItem('authToken');
            localStorage.removeItem('userRole');
            setIsLoggedIn(false);
            setUserRole(null);
          }
        } catch (error) {
          console.error('Token verification failed:', error);
          localStorage.removeItem('authToken');
          localStorage.removeItem('userRole');
          setIsLoggedIn(false);
          setUserRole(null);
        }
      } else {
        setIsLoggedIn(false);
        setUserRole(null);
      }
    };
    checkAuth();
  }, []);

  if (isLoggedIn === null) {
    return <div>Loading...</div>;
  }
  
  return (
    <Router>
      <Routes>
        {/* Public route for login */}
        <Route path="/login" element={<Login setIsLoggedIn={setIsLoggedIn} />} />

        {/* =====  iPad-specific routes ===== */}
        <Route 
          path="/ipad/login" 
          element={<IpadLogin setIsLoggedIn={setIsLoggedIn} setUserRole={setUserRole} />} 
        /> 
        <Route 
          path="/ipad/scanner" 
          element={
            isLoggedIn 
              ? <IpadScanner /> 
              : <Navigate to="/ipad/login" replace />
          } 
        />
        {/* Private routes */}
        {isLoggedIn ? (
          <Route path="/" element={<Layout setIsLoggedIn={setIsLoggedIn} />}>
            <Route index element={<Dashboard />} />
            <Route path="classManagement" element={<ClassManagement />} />
            <Route path="videoClassManagement" element={<VideoClassManagement />} />
            <Route path="courseManagement" element={<CourseManagement />} />
            <Route path="quizManagement" element={<QuizManagement />} />
            <Route path="students" element={<Students />} />
            <Route path="messages" element={<Messages />} />
            <Route path="support" element={<Support />} />
            <Route path="settings" element={<Settings />} />
            <Route path="performanceTracker" element={<PerformanceTracker />} />  
            <Route path="invoice" element={<Navigate to="/payment" replace />} />
            <Route path="staffs" element={<Staffs />} />
            <Route path="payment" element={<Payment />} />
            <Route path="token" element={<Token />} />
            <Route path="timeTable" element={<TimeTable/>} />
            <Route path="transactionHistory" element={<TransactionHistory/>} />
            <Route path="statistics" element={<Statistics/>} />
          </Route>
        ) : (
          <Route path="*" element={<Navigate to="/login" />} />
        )}
      </Routes>
    </Router>
  );
}

export default App;
